import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, X } from "lucide-react";

const T = {
  fr: {
    title: "🔐 Protection de vos données",
    text: "Fodindin respecte votre vie privée. Vos données biométriques et financières sont protégées (RGPD, loi ivoirienne, directives UEMOA).",
    link: "Voir notre charte complète",
    accept: "✅ J'accepte",
  },
  wo: {
    title: "🔐 Aar sa liggéey yi",
    text: "Fodindin dafay aar sa sutura. Sa liggéey biométri ak xaalis dañu leen aar (RGPD, yoonu Côte d'Ivoire, UEMOA).",
    link: "Xool sëriñ bi lépp",
    accept: "✅ Dëgg naa",
  },
  di: {
    title: "🔐 Tɔ́ɔrɔn sa liggéey yi",
    text: "Fodindin bɛ sa sutura tɔ́ɔrɔn. Sa liggéey biométri ni wari bɛ tɔ́ɔrɔn (RGPD, Côte d'Ivoire sariya, UEMOA).",
    link: "Sëriñ bɛɛ lajɛ",
    accept: "✅ N sɔ̀nna",
  },
  bm: {
    title: "🔐 I ka kunnafoniw lakana",
    text: "Fodindin bɛ i ka sutura lakana. I ka biométri ni wari kunnafoniw bɛ lakana (RGPD, Côte d'Ivoire sariya, UEMOA).",
    link: "Sariya bɛɛ lajɛ",
    accept: "✅ N sɔ̀nna",
  },
};

export const RgpdBanner = () => {
  const [visible, setVisible] = useState(() => localStorage.getItem("rgpd_accepted") !== "1");
  const lang = localStorage.getItem("bio_guide_lang") || "fr";
  const t = T[lang] || T.fr;

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem("rgpd_accepted", "1");
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-4 right-4 left-4 sm:left-auto sm:max-w-sm z-[60] bg-white rounded-2xl shadow-2xl border border-[var(--line)] p-4 animate-in slide-in-from-bottom-4"
      data-testid="rgpd-banner"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-400 text-white grid place-items-center shrink-0">
          <ShieldCheck size={17} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-bold text-sm">{t.title}</div>
          <p className="text-xs text-[var(--ink-soft)] mt-1 leading-relaxed">
            {t.text}{" "}
            <Link to="/confidentialite" className="text-orange-600 font-semibold" data-testid="rgpd-banner-link">
              {t.link}
            </Link>
          </p>
          <button
            type="button"
            onClick={accept}
            className="mt-3 px-4 py-2 rounded-full text-xs font-bold bg-emerald-600 text-white hover:bg-emerald-700 transition-colors"
            data-testid="rgpd-accept-btn"
          >
            {t.accept}
          </button>
        </div>
        <button type="button" onClick={() => setVisible(false)} className="text-gray-400 hover:text-gray-600 shrink-0" data-testid="rgpd-close-btn" aria-label="Fermer">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};
